const getSpecs = () => [];
export default getSpecs;
